import { render, staticRenderFns } from "./BaseAppFooter.vue?vue&type=template&id=441c1fb2&scoped=true&"
import script from "./BaseAppFooter.vue?vue&type=script&lang=js&"
export * from "./BaseAppFooter.vue?vue&type=script&lang=js&"
import style0 from "./BaseAppFooter.vue?vue&type=style&index=0&id=441c1fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441c1fb2",
  null
  
)

export default component.exports